import { linkMerge, dividerMerge, layoutMerge } from './merge'

export default function(hideList) {
  let list = [
    linkMerge({
      setting: {
        disabled: false,
        type: 'primary',
        underline: true,
        href: '',
        icon: '',
        target: '_blank',
        text: '这里是链接文本'
      }}),
    dividerMerge({
      setting: {
        direction: 'horizontal',
        contentPosition: 'center',
        content: '这里是分割线',
        icon: ''
      }
    }),
    layoutMerge({
      setting: {
        gutter: 0,
        col: 1,
        colList: [undefined]
      }
    })
  ]
  if (typeof hideList === 'string') {
    list = list.filter(item => item.name !== hideList)
  } else if (Object.prototype.toString.call(hideList) === '[object Array]' && hideList.length) {
    list = list.filter(item => !hideList.find(i => i === item.name))
  }
  return list
}
